import { IAction } from '~/src/store';

import { EPaymentActions } from './index';

export type TPaymentTransaction = {
    id: string,
    payed: boolean,
}

export type TSetTransactions = IAction<EPaymentActions.SET_TRANSACTIONS, TPaymentTransaction[]>

const setTransactions = (payload: TPaymentTransaction[]): TSetTransactions => ({
    type: EPaymentActions.SET_TRANSACTIONS,
    payload,
});

export default setTransactions;
